<template>
  <div>
    <!-- <v-btn color="black" class="white--text" @click="dialog = true"
      ><v-icon>mdi-magnify</v-icon> Seller
    </v-btn> -->
    <v-card>
      <v-card-text>
        <v-row v-if="value.product_supplier_id !== ''">
          <v-col cols="12" md="5">
            <v-row>
              <v-col cols="3" class="py-0 pr-0">
                <v-img width="100%" :src="value.product_supplier_image"></v-img>
              </v-col>
              <v-col cols="9" class="py-0">
                <div class="text-deco">
                  <div
                    class="text-uppercase black--text font-weight-bold text-subtitle-2"
                  >
                    {{ value.product_supplier_name }}
                  </div>
                </div>
                <div class="d-flex">
                  <v-btn
                    color="black"
                    class="white--text"
                    @click="dialog = true"
                  >
                    Ganti Supplier
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" md="5">
            <v-row>
              <v-col cols="3" class="py-0 pr-0">
                <v-img width="100%" src="/assets/seller/default-toko.svg"></v-img>
                <!-- <v-skeleton-loader
                  class="mx-auto"
                  max-width="300"
                  type="card"
                ></v-skeleton-loader> -->
              </v-col>
              <v-col cols="9" class="py-0">
                <div class="text-deco">
                  <div
                    class="text-uppercase black--text font-weight-bold text-subtitle-2"
                  >&nbsp;</div>
                </div>
                <div class="d-flex">
                  <v-btn
                    color="black"
                    class="white--text"
                    @click="dialog = true"
                    ><v-icon>mdi-magnify</v-icon> Pilih Supplier
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" max-width="1000">
      <v-card>
        <div>
          <v-container>
            <v-row v-if="listData.length > 0">
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  label="Search"
                  solo
                ></v-text-field>
                <v-list dense>
                  <v-virtual-scroll
                    v-model="selectedItem"
                    :items="filteredItems"
                    item-height="100"
                    height="400"
                    :debounce-search="300"
                  >
                    <template v-slot="{ item }">
                      <v-list-item :value="item" @click="selectItem(item)">
                        <v-list-item-avatar
                          width="100"
                          height="100"
                          rounded="0"
                        >
                          <v-img contain :src="item.product_supplier_image" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.product_supplier_name
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-virtual-scroll>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
    
    <script>
export default {
  props: {
    listData: {
      type:Array,
      default:() => []
    },
    value: Object,
  },
  watch: {
    value(nv, ov) {
      if (nv == null) {
        this.selectedItem = null;
      } else {
        this.selectedItem = nv;
      }
    },
  },
  data() {
    return {
      selectedItem: this.value,
      search: "",
      dialog: false,
    };
  },
  computed: {
    filteredItems() {
      const lowerSearch = this.search.toLowerCase();
      return this.listData.filter((item) =>
        item.product_supplier_name.toLowerCase().includes(lowerSearch)
      );
    },
  },
  methods: {
    emitInput() {
      // Emit event input saat nilai dropdown berubah
      this.$emit("input", this.selectedItem);
    },
    selectItem(item) {
      this.dialog = false;
      this.selectedItem = item;
      this.emitInput();
      this.$emit("change");
    },
  },
};
</script>